import React, {Component, lazy, Suspense} from 'react';
import {Switch, Route, withRouter} from "react-router-dom";

import RouteManager from "./view/page/RouteManager";

import './App.css';

const Register = lazy(() => import('./view/page/register/Register'));
const Login = lazy(() => import('./view/page/login/Login'));
const Reset = lazy(() => import('./view/page/reset/Reset'));
const Admin = lazy(() => import('./view/page/admin/Admin'));
const Index = lazy(() => import('./view/page/index/Index'));

class App extends Component {
    render() {
        return (
            <Suspense fallback={<div>Loading...</div>}>
                <Switch>
                    {/* 备注：顺序会影响路由规则 */}
                    <Route path={RouteManager.URL_REGISTER} component={Register}/>
                    <Route path={RouteManager.URL_LOGIN} component={Login}/>
                    <Route path={RouteManager.URL_RESET} component={Reset}/>
                    <Route path={RouteManager.URL_ADMIN} component={Admin}/>
                    <Route path={RouteManager.URL_INDEX} component={Index}/>
                </Switch>
            </Suspense>
        );
    }
}

export default withRouter(App);
